<template>
    <div class="shipping product-shipping">
        <ValidationObserver v-slot="{ handleSubmit }" slim ref="observer">
            <form action="#" method="post" @submit.prevent="handleSubmit(listShipping)">
                <ValidationObserver v-slot="{ handleSubmit }" slim ref="observer">
                    <form action="#" method="post" @submit.prevent="handleSubmit(onSubmit)">
                        <ValidationProvider name="CEP" :rules="{ required: true, regex: /^\d{5}-?\d{3}$/ }" tag="div" v-slot="{ errors, classes, required }">
                            <div class="input-group">
                                <the-mask
                                    type="tel"
                                    class="form-control"
                                    id="cep"
                                    name="cep"
                                    v-model="cep"
                                    :mask="['#####-###']"
                                    :masked="true"
                                    style="min-height: 40px;"
                                />
                                <div class="input-group-append">
                                    <button type="submit" class="btn-default btn-reverse-color p-y px-2">
                                        Consultar
                                    </button>
                                </div>
                            </div>
                            <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                        </ValidationProvider>
                    </form>
                </ValidationObserver>
            </form>
        </ValidationObserver>
        <ModalShipping :cep="cep" v-if="cep" @cep_changed="cep_changed" :product_code="code" :product_qty="qty"/>
    </div>
</template>

<script>
    import {ValidationProvider, ValidationObserver} from "vee-validate";
    import {TheMask} from "vue-the-mask";
    import ModalShipping from '~/components/ModalShipping.vue';
    import Cookies from 'js-cookie';

    export default {
        props: {
            code: {
                default: 0
            },
            qty: {
                default: 1
            }
        },
        components: {
            ValidationProvider,
            ValidationObserver,
            TheMask,
            ModalShipping
        },
        data() {
            return {
                cep: ''
            }
        },
        mounted() {
            if (Cookies.get("shipping_cep") && /^\d{5}-?\d{3}$/.test(Cookies.get("shipping_cep"))) {
                this.cep = Cookies.get("shipping_cep")
            }
        },
        methods: {
            async onSubmit() {
                this.$bvModal.show('modal-shipping-info')
            },
            cep_changed(cep) {
                this.cep = cep
                Cookies.set("shipping_cep", this.cep)
            }
        }
    }
</script>
